import React from "react";
import { toast } from "sonner";
import { Sparkles, Check, AlertTriangle, Quote, Copy, Send } from "lucide-react";

// Drop the AI opening line into an outreach body: greeting, the opener, then everything after the default intro paragraph.
export const bodyWithOpener = (body, opener) => {
  let line = (opener || "").trim();
  if (!line) return body;
  const paras = (body || "").split(/\n\n/);
  const first = ((paras[0] || "").match(/^\s*(?:hi|hello|hey|dear)\s+([A-Za-z'.-]+)/i) || [])[1];
  if (first) { const re = new RegExp(`^${first.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*[—–,:-]+\\s*`, "i"); line = line.replace(re, ""); line = line.charAt(0).toUpperCase() + line.slice(1); }
  return [paras[0], line, ...paras.slice(2)].join("\n\n");
};

export const FitNotes = ({ notes, label = "Why they could be the perfect fit", testid, onUseOpener, canEmail = true }) => {
  const n = notes || {};
  const why = (n.why || []).filter(Boolean);
  if (!why.length && !n.hook && !n.risk && !n.opener) {
    return <div className="om-rationale" data-testid={testid}>No AI notes yet — score this record to generate them.</div>;
  }
  const copy = () => { navigator.clipboard?.writeText(n.opener || ""); toast.success("Opening line copied"); };
  return (
    <div className="fit-notes" data-testid={testid}>
      <div className="fit-notes-h"><Sparkles size={11} />{label}</div>
      {why.length > 0 && <ul className="fit-why">{why.map((w, i) => <li key={i}><Check size={11} />{w}</li>)}</ul>}
      {n.hook && <div className="fit-line hook"><span>Best angle</span>{n.hook}</div>}
      {n.risk && <div className="fit-line risk"><span><AlertTriangle size={10} /> Watch</span>{n.risk}</div>}
      {n.opener && (
        <div className="fit-opener">
          <div className="fit-opener-h"><span><Quote size={10} /> Opening line</span>
            <span className="fit-opener-acts">
              {onUseOpener && (
                <button className="btn btn-sm btn-lime" onClick={() => onUseOpener(n.opener)} disabled={!canEmail}
                  title={canEmail ? "Open the email composer with this line as the first paragraph" : "Find the contact's email first"}
                  data-testid={testid ? `${testid}-email` : undefined}><Send size={11} />Start email</button>
              )}
              <button className="btn btn-sm" onClick={copy} data-testid={testid ? `${testid}-copy` : undefined}><Copy size={11} />Copy</button>
            </span></div>
          <div className="fit-opener-b">{n.opener}</div>
        </div>
      )}
    </div>
  );
};
